function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border: 1px solid var(--theme-border, #e5e7eb);\n  border-radius: 0.375rem;\n  background-color: var(--theme-paper-alt, #f9fafb);\n  color: var(--theme-text, inherit);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem;\n  border-bottom: 1px solid var(--theme-border, #e5e7eb);\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: var(--theme-paper-hover, #f3f4f6);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  margin-right: 0.25rem;\n  color: var(--theme-text-secondary, #6b7280);\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  font-weight: 500;\n  font-size: 0.875rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.75rem;\n  color: var(--theme-text-muted, #6b7280);\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  padding: 0.5rem;\n  max-height: 24rem;\n  overflow-y: auto;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: flex-start;\n  padding: 0.25rem 0.25rem;\n  cursor: pointer;\n  border-radius: 0.25rem;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: var(--theme-paper-hover, #f3f4f6);\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  margin-right: 0.25rem;\n  margin-top: 0.125rem;\n  color: var(--theme-text-secondary, #6b7280);\n  flex-shrink: 0;\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  margin-right: 0.5rem;\n  margin-top: 0.125rem;\n  flex-shrink: 0;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--theme-text-secondary, #6b7280);\n  word-break: break-all;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  margin-left: 1rem;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  text-align: center;\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  height: 2.5rem;\n  width: 2.5rem;\n  color: var(--theme-icon-muted, #9ca3af);\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  color: var(--theme-text-muted, #6b7280);\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState } from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import DefaultFileIcon from 'lucide-react/dist/esm/icons/file';
import FolderIcon from 'lucide-react/dist/esm/icons/folder';
import FileText from 'lucide-react/dist/esm/icons/file-text';
import FileCode from 'lucide-react/dist/esm/icons/file-code';
import Package from 'lucide-react/dist/esm/icons/package';
import ChevronRight from 'lucide-react/dist/esm/icons/chevron-right';
import ChevronDown from 'lucide-react/dist/esm/icons/chevron-down';
import { getFileIcon } from '@edusense/shared-utils';
import styled from '@emotion/styled';
// --- Emotion 스타일 컴포넌트 정의 ---
var TreeWrapper = styled.div(_templateObject());
var Header = styled.div(_templateObject1());
var HeaderTitleContainer = styled.div(_templateObject2());
var HeaderIcon = styled.span(_templateObject3());
var HeaderTitle = styled.span(_templateObject4());
var HeaderCount = styled.span(_templateObject5());
var TreeContent = styled.div(_templateObject6());
var NodeList = styled.ul(_templateObject7());
var NodeListItem = styled.li(_templateObject8());
var NodeItem = styled.div(_templateObject9());
var NodeToggleIcon = styled.span(_templateObject10());
var NodeIcon = styled.div(_templateObject11());
var NodeName = styled.span(_templateObject12());
var SubTreeList = styled.ul(_templateObject13());
var EmptyStateContainer = styled.div(_templateObject14());
var EmptyStateIconWrapper = styled.div(_templateObject15());
var EmptyStateIcon = function() {
    return /*#__PURE__*/ React.createElement(EmptyStateIconWrapper, null, /*#__PURE__*/ React.createElement(FolderIcon, {
        style: {
            width: '100%',
            height: '100%'
        }
    }));
};
var EmptyStateText = styled.p(_templateObject16());
// --- 컴포넌트 구현 ---
var FileTree = function(param) {
    var fileTree = param.fileTree, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    var _useState = _sliced_to_array(useState(true), 2), isTreeOpen = _useState[0], setIsTreeOpen = _useState[1];
    if (!fileTree) {
        return /*#__PURE__*/ React.createElement(EmptyStateContainer, null, /*#__PURE__*/ React.createElement(EmptyStateIcon, null), /*#__PURE__*/ React.createElement(EmptyStateText, null, "프로젝트 파일 정보가 없습니다."));
    }
    var toggleTree = function() {
        setIsTreeOpen(!isTreeOpen);
    };
    var TreeNode = function(param) {
        var name = param.name, node = param.node, _param_path = param.path, path = _param_path === void 0 ? '' : _param_path;
        var _useState = _sliced_to_array(useState(true), 2), isOpen = _useState[0], setIsOpen = _useState[1];
        var currentPath = path ? "".concat(path, "/").concat(name) : name;
        var isDir = node && (typeof node === "undefined" ? "undefined" : _type_of(node)) === 'object' && 'directory' in node;
        var toggleFolder = function(e) {
            e.stopPropagation();
            if (isDir) {
                setIsOpen(!isOpen);
            }
        };
        var icon = /*#__PURE__*/ React.createElement(DefaultFileIcon, {
            className: "h-4 w-4 text-[var(--theme-icon-default,#6b7280)]"
        });
        var iconColorClass = 'text-[var(--theme-icon-default,#6b7280)]';
        if (isDir) {
            icon = /*#__PURE__*/ React.createElement(FolderIcon, {
                className: "h-4 w-4 text-blue-500"
            });
            iconColorClass = 'text-blue-500';
        } else if (node && (typeof node === "undefined" ? "undefined" : _type_of(node)) === 'object' && 'file' in node) {
            var fileIconInfo = getFileIcon(name);
            iconColorClass = fileIconInfo.color;
            switch(fileIconInfo.icon){
                case 'FileText':
                    icon = /*#__PURE__*/ React.createElement(FileText, {
                        className: "h-4 w-4 ".concat(iconColorClass)
                    });
                    break;
                case 'FileCode':
                    icon = /*#__PURE__*/ React.createElement(FileCode, {
                        className: "h-4 w-4 ".concat(iconColorClass)
                    });
                    break;
                case 'Package':
                    icon = /*#__PURE__*/ React.createElement(Package, {
                        className: "h-4 w-4 ".concat(iconColorClass)
                    });
                    break;
                default:
                    icon = /*#__PURE__*/ React.createElement(DefaultFileIcon, {
                        className: "h-4 w-4 ".concat(iconColorClass)
                    });
            }
        }
        return /*#__PURE__*/ React.createElement(NodeListItem, null, /*#__PURE__*/ React.createElement(NodeItem, {
            onClick: toggleFolder
        }, isDir && /*#__PURE__*/ React.createElement(NodeToggleIcon, null, isOpen ? /*#__PURE__*/ React.createElement(ChevronDown, {
            className: "h-3 w-3"
        }) : /*#__PURE__*/ React.createElement(ChevronRight, {
            className: "h-3 w-3"
        })), !isDir && /*#__PURE__*/ React.createElement("span", {
            className: "w-3 mr-1 flex-shrink-0"
        }), /*#__PURE__*/ React.createElement(NodeIcon, null, icon), /*#__PURE__*/ React.createElement(NodeName, null, name, isDir ? '/' : '')), isDir && isOpen && node.directory && Object.keys(node.directory).length > 0 && /*#__PURE__*/ React.createElement(SubTreeList, null, Object.entries(node.directory).map(function(param) {
            var _param = _sliced_to_array(param, 2), childName = _param[0], childValue = _param[1];
            return /*#__PURE__*/ React.createElement(TreeNode, {
                key: "".concat(currentPath, "/").concat(childName),
                name: childName,
                node: childValue,
                path: currentPath
            });
        })));
    };
    return /*#__PURE__*/ React.createElement(TreeWrapper, {
        className: className
    }, /*#__PURE__*/ React.createElement(Header, {
        onClick: toggleTree
    }, /*#__PURE__*/ React.createElement(HeaderTitleContainer, null, /*#__PURE__*/ React.createElement(HeaderIcon, null, isTreeOpen ? /*#__PURE__*/ React.createElement(ChevronDown, {
        className: "h-4 w-4"
    }) : /*#__PURE__*/ React.createElement(ChevronRight, {
        className: "h-4 w-4"
    })), /*#__PURE__*/ React.createElement(HeaderTitle, null, "파일 구조")), /*#__PURE__*/ React.createElement(HeaderCount, null, Object.keys(fileTree || {}).length, "개 항목")), isTreeOpen && /*#__PURE__*/ React.createElement(TreeContent, null, /*#__PURE__*/ React.createElement(NodeList, null, Object.entries(fileTree || {}).map(function(param) {
        var _param = _sliced_to_array(param, 2), name = _param[0], value = _param[1];
        return /*#__PURE__*/ React.createElement(TreeNode, {
            key: name,
            name: name,
            node: value
        });
    }))));
};
/**
 * 🏗️ FSD Shared Layer - UI File Tree
 * 
 * 파일 시스템 트리 구조를 시각적으로 표시하는 컴포넌트
 * WebContainer API의 FileSystemTree 형식을 지원합니다.
 */ export default FileTree;
